import {Box, Flex, Image, Text} from "@mantine/core";
import {IconMinus, IconPlus, IconTrash} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';


const _CartItem2 = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Box
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
                px={component?.customize_styles?.box_decoration?.padding_x}
                py={component?.customize_styles?.box_decoration?.padding_y}
                bg={component?.customize_styles?.box_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                }}
            >
                <Flex justify={'flex-start'} align={'center'} mb={20} gap="xs">
                    <Box
                        w={component?.customize_styles?.image_decoration?.width}
                        h={component?.customize_styles?.image_decoration?.height}
                        // bg={component?.customize_styles?.image_decoration?.color}
                        style={{
                            borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`
                        }}
                    >
                        <Image
                            style={{ width: "100%", height: "100%" }}
                            src=""
                            fallbackSrc={ProductPlaceholderImage}
                            alt=""
                            radius={component?.customize_styles?.image_decoration?.radius}
                        />
                    </Box>
                    <Box>

                        <Text
                            lineClamp={1}
                            translate="yes"
                            c={component?.customize_styles?.name_text_decoration?.color}
                            fw={component?.customize_styles?.name_text_decoration?.font_weight}
                            fz={component?.customize_styles?.name_text_decoration?.font_size}
                            fs={component?.customize_styles?.name_text_decoration?.font_style}
                        >
                            Product Name
                        </Text>
                        <Flex>
                            <Text
                                c={component?.customize_styles?.product_discount_text_decoration?.color}
                                fz={component?.customize_styles?.product_discount_text_decoration?.font_size}
                                fw={component?.customize_styles?.product_discount_text_decoration?.font_weight}
                                ta={component?.customize_styles?.product_discount_text_decoration?.text_align}
                                lh={component?.customize_styles?.product_discount_text_decoration?.text_height}
                                style={{ textDecoration: "line-through" }}
                                bg={component?.customize_styles?.product_discount_text_decoration?.background_color}
                            >
                                $00.00
                            </Text>
                            <Text
                                fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                c={component?.customize_styles?.product_price_text_decoration?.color}
                                // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                ta={component?.customize_styles?.product_price_text_decoration?.text_align}
                            >
                                $00.00
                            </Text>
                        </Flex>
                    </Box>
                </Flex>
                <Flex justify={'space-between'} align={'center'}>
                    {/* Qty */}
                    <Flex align={'center'}>
                        <Flex w={23} h={20} bg={'#262626'} justify={'center'} align={'center'} style={{ border: "2px solid #2F3134", borderRadius: "4px", cursor: "pointer" }}>
                            <IconMinus color="#ffffff" size={13} />
                        </Flex>
                        <Text c={'#ffffff'} mx={10} fz={16} fw={500}>1</Text>
                        <Flex w={23} h={20} bg={'#262626'} justify={'center'} align={'center'} style={{ border: "2px solid #2F3134", borderRadius: "4px", cursor: "pointer" }}>
                            <IconPlus color="#ffffff" size={13} />
                        </Flex>
                    </Flex>
                    {/* Remove */}
                    <Flex>
                        <IconTrash color="#7c7c7c" size={20} />
                        <Text c={'#7C7C7C'} fz={14} fw={500} ml={5} style={{ cursor: "pointer" }}>Remove</Text>
                    </Flex>
                </Flex>
            </Box>

        </Box>
    )
}
export default _CartItem2;